<template>
  <header class="event-modal-passes-header">
    <div class="event-modal-passes-header__info">
      <h1 class="event-modal-passes-header__info-title">
        <slot name="title">Заголовок</slot>
      </h1>

      <div class="event-modal-passes-header__info_no-mobile">
        <slot name="doc-link" />

        <p
          class="event-modal-passes-header__info-deadlines"
          v-if="!!$slots['deadlines-text']"
        >
          <icon name="info-grey" /> <slot name="deadlines-text" />
        </p>

        <p
          class="event-modal-passes-header__info-deadlines"
          v-if="!!$slots['pass-warning']"
        >
          <icon name="info-grey" /> <slot name="pass-warning" />
        </p>
        <p
          class="event-modal-passes-header__info-deadlines"
          v-if="!!$slots['pass-warning2']"
        >
          <icon name="info-grey" /> <slot name="pass-warning2" />
        </p>

        <button
          class="event-modal-passes-header__info-rules"
          v-if="!!$slots['rules-title']"
          @click="isRulesShown = !isRulesShown"
        >
          <slot name="rules-title" />
          <icon name="arrow-down_grey" :class="{ _rotated: isRulesShown }" />
        </button>
      </div>
    </div>
    <div class="event-modal-passes-header__quotas">
      <EventCardQuota
        v-if="options.quota && !hideQuota"
        :count="options.quota.count"
        :total="options.quota.total"
      >
        <slot name="quota-text" />
      </EventCardQuota>

      <Notification
        v-if="options.deadline && secondsToDeadline >= 0"
        :class="{ _warning: secondsToDeadline <= 60 * 60 * 24 * 10 }"
        modify="_flex _documents"
      >
        {{ locale === "en" ? "Until" : "Не позднее" }}
        {{ localeDate }}
      </Notification>

      <EventModalPassesActions
        v-if="isShowEventModalPassesActions"
        @download="$emit('download')"
        @print="$emit('print')"
      />

      <div
        v-if="!!$slots['warning-message']"
        class="event-modal-passes-header__warning-message"
      >
        <slot name="warning-message"></slot>
      </div>
    </div>

    <div class="event-modal-passes-header__info_mobile">
      <slot name="doc-link" />

      <p
        class="event-modal-passes-header__info-deadlines"
        v-if="!!$slots['deadlines-text']"
      >
        <icon name="info-grey" /> <slot name="deadlines-text" />
      </p>

      <button
        class="event-modal-passes-header__info-rules"
        v-if="!!$slots['rules-title']"
        @click="isRulesShown = !isRulesShown"
      >
        <slot name="rules-title" />
        <icon name="arrow-down_grey" :class="{ _rotated: isRulesShown }" />
      </button>
    </div>

    <div
      class="event-modal-passes-header__rules"
      v-if="!!$slots['rules-content']"
      :class="{ _active: isRulesShown }"
    >
      <slot name="rules-content" />
    </div>
    <div class="event-modal-passes-header__rules _active">
      <slot name="pass_terms"></slot>
    </div>
  </header>
</template>

<script>
import { Notification } from "@v2/shared/ui/components";
import EventCardQuota from "@/components/Custom/EventCardQuota.vue";
import EventModalPassesActions from "./EventModalPassesActions.vue";

import diffInSeconds from "@/helpers/diffInSeconds";

import { i18n } from "@v2/shared/config";
import moment from "moment/moment";
import { mapGetters } from "vuex";
moment.locale(i18n.locale);
export default {
  name: "EventModalPassesHeader",

  props: {
    options: {
      type: Object,
      default: () => ({
        quota: {
          count: null,
          total: null
        },
        deadline: null,
        deadlineStartPrint: null,
        deadlineEndPrint: null,
        passes: []
      })
    },
    hideQuota: {
      type: Number,
      default: 0
    },
    showRules: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Notification,
    EventCardQuota,
    EventModalPassesActions
  },
  data() {
    return {
      isRulesShown: this.showRules
    };
  },
  computed: {
    ...mapGetters("event", ["subParticipantAviableQuotas"]),
    localeDate() {
      return this.options.deadline.locale(i18n.locale).format("DD MMMM YYYY");
    },
    locale() {
      return i18n.locale;
    },

    secondsToDeadline() {
      if (!this.options || !this.options.deadline) {
        return Infinity;
      }

      return diffInSeconds(this.options.deadline);
    },

    secondsFromDeadlinePrint() {
      if (!this.options || !this.options.deadlineStartPrint) {
        return Infinity;
      }

      return diffInSeconds(this.options.deadlineStartPrint);
    },

    secondsToDeadlinePrint() {
      if (!this.options || !this.options.deadlineEndPrint) {
        return Infinity;
      }

      return diffInSeconds(this.options.deadlineEndPrint);
    },
    isAllPassesVisa() {
      return this.options.passes?.every(pass => pass.type === "visa");
    },
    isSomePassAccepted() {
      return this.options.passes?.some(pass => pass.status === "accepted");
    },
    isShowEventModalPassesActions() {
      return (
        this.secondsFromDeadlinePrint < 0 &&
        this.secondsToDeadlinePrint > 0 &&
        this.options.quota.count &&
        !this.isAllPassesVisa &&
        this.isSomePassAccepted &&
        !this.hideQuota
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";
.event-modal-passes-header {
  width: 780px;

  padding: 56px 0 56px 80px;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @include respond-down(lg) {
    padding: 40px 24px 44px 24px;

    width: 100%;
    box-sizing: border-box;
  }

  @include respond-down(md) {
    box-sizing: border-box;

    padding: 24px 16px 34px 16px;

    width: 100%;
  }
  &__amount {
    border-radius: 2px;
    background-color: #f9f9f9;
    padding: 14px 27px;
    color: #6d7179;
    position: relative;
  }
  &__info {
    width: 428px;

    @include respond-down(lg) {
      width: 388px;
    }

    @include respond-down(md) {
      width: 100%;
    }

    &-title {
      @include h1();
      margin-bottom: 35px;

      @include respond-down(md) {
        max-width: 244px;
        margin-bottom: 24px;
      }
    }

    &_mobile {
      display: none;

      @include respond-down(md) {
        display: block;
        margin-top: 24px;
      }
    }

    &_no-mobile {
      @include respond-down(md) {
        display: none;
      }
    }

    &-deadlines {
      @include description();

      margin-top: 18px;
      margin-bottom: 25px;

      color: #000;

      display: flex;

      .svg-icon {
        width: 17px;
        height: 17px;

        flex-shrink: 0;

        margin-top: 2px;
        margin-right: 9px;
      }
    }

    &-rules {
      @include button-clean();

      display: flex;
      align-items: center;

      font-size: 14px;
      font-weight: 500;
      line-height: 1.43;
      color: #6d7179;

      @include respond-down(md) {
        text-align: left;
      }

      .svg-icon {
        width: 11px;
        height: 11px;

        flex-shrink: 0;

        margin-left: 7px;

        &._rotated {
          transform: rotate(180deg);
        }
      }
    }
  }

  &__quotas {
    width: 300px;

    @include respond-down(md) {
      width: 100%;
    }

    .notification {
      margin-top: 16px;
      padding-left: 28px;
    }

    .event-modal-passes-actions {
      margin-top: 16px;
    }
  }

  &__rules {
    @include description();

    width: 100%;

    margin-top: 20px;

    display: none;

    @include respond-down(md) {
      margin-top: 0;
      font-size: 11px;
    }

    &._active {
      display: block;
    }

    table {
      width: 100%;
      border-spacing: 0;
      border-collapse: collapse;

      th {
        text-align: left;
      }
    }
  }

  &__warning-message {
    display: block;
    position: relative;
    margin-top: 16px;
    padding: 18px 25px 21px 53px;

    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    border-radius: 2px;
    color: #ea5330;
    background-color: rgba(234, 83, 48, 0.1);

    .svg-icon {
      display: block;
      position: absolute;
      top: 18px;
      left: 25px;
      width: 16px;
      height: 16px;
    }
  }
}
</style>
